const styles = {
  item: {
    color: 'kit.text.accent',
    border: '1px solid transparent',
    borderColor: 'kit.stroke.turquoise',
    borderRadius: '8px',
    padding: {
      xs: '4px 8px',
      xl: '8px 16px',
    },
    fontFamily: 'RF Rostin',
    fontWeight: 700,
    fontSize: { xs: '12px', xl: '14px' },
    lineHeight: 1.2,
    textAlign: 'center',
    letterSpacing: '-0.01em',
    textTransform: 'uppercase',
  },
};

export default styles;
